/**
 * @file 全局逻辑守护层
 * @description 挂载全站级拦截器、权限监听器，确保整个应用生命周期内仅挂载一次。
 * 必须置于 RouterProvider 内部（依赖 router context）。
 */

import {Outlet} from 'react-router-dom';
import axios from 'axios';
import styles from './index.module.less';
import StatusView from '@/components/common/StatusView';
import MembershipModal from '@/commerce/modals/MembershipModal';
import {useProjectPermissions} from '@/hooks/useProjectPermissions';
import {useProjectBenefitProfile} from '@/commerce/benefit/hooks/useBenefitProfile';
import {ChatSdkProvider} from '@/platform/agentBridge';
import {ERROR_MESSAGES} from '@/constants';
import PointsInsufficientModal from '@/commerce/modals/PointsInsufficientModal';
import PointsRechargeModal from '@/commerce/modals/PointsRechargeModal';
import PointsModal from '@/components/PointsModal';

const GlobalLogicLayout = () => {
    const permQuery = useProjectPermissions();
    // 进入项目页面时预拉会员权益数据
    useProjectBenefitProfile();

    // 首次加载失败（无缓存）→ 渲染错误视图 + 重试，避免 throw 被 React Router 拦截
    // 有旧缓存时 permQuery.data 存在，降级继续渲染页面
    if (permQuery.isError && !permQuery.data) {
        const is403 =
            axios.isAxiosError(permQuery.error) && permQuery.error.response?.status === 403;

        return (
            <div className={styles.errorWrapper}>
                <StatusView
                    status="error"
                    title={
                        is403
                            ? ERROR_MESSAGES.PERMISSION_NO_ACCESS
                            : ERROR_MESSAGES.LOAD_FAILED_MESSAGE
                    }
                    onRetry={is403 ? undefined : () => window.location.reload()}
                    retryText="重试"
                />
            </div>
        );
    }

    return (
        <ChatSdkProvider>
            <Outlet />
            {/* 会员订阅弹窗 */}
            <MembershipModal />
            {/* 积分不足弹窗 */}
            <PointsInsufficientModal />
            {/* 积分充值弹窗 */}
            <PointsRechargeModal />
            {/* 积分消耗详情弹窗 */}
            <PointsModal />
        </ChatSdkProvider>
    );
};

export default GlobalLogicLayout;
